module.exports = __webpack_public_path__ + "static/HappyFeet-30-bc6ba92629bc772b584cebac724bcc2c.jpg";